module.exports = __webpack_public_path__ + "static/media/HalfHexa.c45cb725.svg";